export default {
  withdraw: {
    // 标题 / 头部
    title: 'Withdraw',
    subtitle: 'Fast, secure and convenient',
    secureEncrypted: 'Secure and Encrypted',
    fiatOrCash: 'Fiat/Cash',
    processing: 'Processing...',
    select: 'Select',
    // 表单字段
    withdrawCurrency: 'Withdraw Currency',
    chooseNetwork: 'Choose Network',
    channel: 'Channel',
    withdrawalAddress: 'Withdrawal Address',
    pixKeyType: 'PIX Key Type',
    accountNumber: 'Account Number',
    enterAccountNumber: 'Enter your account number',
    accountName: 'Account Name',
    enterAccountName: 'Enter the account holder name',
    pixKey: 'PIX Key',
    enterPixKey: 'Enter your PIX key',
    cpf: 'CPF',
    enterCpf: 'Enter CPF',
    bankName: 'Bank Name',
    enterBankName: 'Enter the bank name',
    branch: 'Branch',
    enterBranch: 'Enter the branch (optional)',
    phone: 'Phone',
    enterPhone: 'Enter phone (optional)',
    email: 'Email',
    enterEmail: 'Enter email (optional)',
    available: 'Withdrawable',
    amountPlaceholder: 'Amount ({unit})',
    min: 'Min',
    max: 'Max',
    // 汇总
    totalWithdrawalAmount: 'Total withdrawal amount:',
    fee: 'Fee:',
    withdrawalAmount: 'Withdrawal Amount:',
    // 安全提示卡
    fundsSafeTitle: 'Your funds are safe with us',
    fundsSafeDesc: 'We use industry-leading security to protect your transactions and personal information.',
    // 提示 / 报错
    enterWithdrawalAddress: 'Please enter withdrawal address',
    enterAccountNumberRequired: 'Please enter your account number',
    selectChannelRequired: 'Please select a channel',
    enterAccountNameRequired: 'Please enter the account holder name',
    selectPixKeyTypeRequired: 'Please select the PIX key type',
    enterCpfRequired: 'Please enter the CPF',
    enterValidAmount: 'Please enter a valid amount',
    minWithdrawal: 'Minimum withdrawal: {amount} {unit}',
    maxWithdrawal: 'Maximum withdrawal: {amount} {unit}',
    insufficientBalance: 'Insufficient available balance',
    withdrawalRejected: 'Withdrawal rejected',
    submittedPendingReview: 'Withdrawal submitted, pending review',
    submittedPayoutInProgress: 'Withdrawal submitted, payout in progress',
    withdrawalFailed: 'Withdrawal failed',
    withdrawalFailedRetry: 'Withdrawal failed, please try again',
  },
};
